import { styled } from "styled-components";

export const ProfileEditModalMessage = styled.div`
  font-size: 24px;
`;
